import React from 'react';
import { connect } from 'react-redux';
import { IState } from '@/state/IState';
import ProjectOrderDetails from '@/seller/components/project/ProjectOrderDetails';
import ApproveRejectButtons from '@/seller/components/project/ProjectOrderDetails/ApproveRejectButtons';
import theme from './OrderDetails.module.scss';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Order } from '@/types';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';

const mapDispatchToProps = () => ({});
const mapStateToProps = (state: IState) => ({
    profileId: state.global.activeProfile!.id,
});

type OrderDetailsProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> & {
        order: Order;
        onOrderChange: () => void;
    };

const OrderDetails: React.FC<OrderDetailsProps> = ({ order, onOrderChange }) => {
    return (
        <div>
            <SimplePageTitle title={t`Order #${order.id}`} />

            <ProjectOrderDetails onOrderChange={onOrderChange} order={order} />

            <div className={theme.bottomButtons}>
                <ApproveRejectButtons order={order} />
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
